import { ChevronUp, ChevronDown, ChevronsUp, ChevronsDown, Copy, Trash2, Group, Ungroup, Lock, Unlock, Eye, EyeOff } from 'lucide-react';

export function Btn({ active, onClick, title, children, testid, danger, disabled }) {
  return (
    <button type="button" title={title} aria-label={title} onClick={onClick} data-testid={testid} disabled={disabled}
      className={`h-9 min-w-9 px-2 inline-flex items-center justify-center gap-1 rounded-md text-xs font-medium border transition-colors disabled:opacity-40 disabled:pointer-events-none ${
        active ? 'bg-slate-900 text-white border-slate-900' : danger ? 'bg-white text-red-600 border-slate-200 hover:bg-red-50' : 'bg-white text-slate-700 border-slate-200 hover:bg-slate-50'}`}>
      {children}
    </button>
  );
}

export function Field({ label, children }) {
  return (
    <label className="flex items-center gap-2 text-[11px] font-medium uppercase tracking-wide text-slate-500">
      <span className="whitespace-nowrap">{label}</span>{children}
    </label>
  );
}

const L = ({ children }) => <span className="hidden sm:inline">{children}</span>;

// Actions for the current selection (one or many objects / groups).
export function ArrangeBar({ count, canGroup, canUngroup, allLocked, allHidden, onArrange, onGroup, onUngroup, onLock, onHide, onDuplicate, onDelete }) {
  return (
    <div data-testid="wb-arrange-bar" className="flex flex-wrap items-center gap-1.5">
      <span data-testid="wb-selection-count" className="text-[11px] font-medium uppercase tracking-wide text-slate-500 mr-1">{count} selected</span>
      <Btn title="Bring forward" onClick={() => onArrange('forward')} testid="wb-forward"><ChevronUp className="h-4 w-4" /><L>Forward</L></Btn>
      <Btn title="Send backward" onClick={() => onArrange('backward')} testid="wb-backward"><ChevronDown className="h-4 w-4" /><L>Backward</L></Btn>
      <Btn title="Bring to front" onClick={() => onArrange('front')} testid="wb-to-front"><ChevronsUp className="h-4 w-4" /><L>Front</L></Btn>
      <Btn title="Send to back" onClick={() => onArrange('back')} testid="wb-to-back"><ChevronsDown className="h-4 w-4" /><L>Back</L></Btn>
      <Btn title="Group" onClick={onGroup} disabled={!canGroup} testid="wb-group"><Group className="h-4 w-4" />Group</Btn>
      <Btn title="Ungroup" onClick={onUngroup} disabled={!canUngroup} testid="wb-ungroup"><Ungroup className="h-4 w-4" />Ungroup</Btn>
      <Btn title={allLocked ? 'Unlock' : 'Lock'} onClick={onLock} active={allLocked} testid="wb-lock">
        {allLocked ? <Lock className="h-4 w-4" /> : <Unlock className="h-4 w-4" />}<L>{allLocked ? 'Locked' : 'Lock'}</L>
      </Btn>
      <Btn title={allHidden ? 'Show' : 'Hide'} onClick={onHide} testid="wb-hide">
        {allHidden ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}<L>{allHidden ? 'Show' : 'Hide'}</L>
      </Btn>
      <Btn title="Duplicate" onClick={onDuplicate} testid="wb-duplicate"><Copy className="h-4 w-4" /><L>Duplicate</L></Btn>
      <Btn title="Delete" onClick={onDelete} testid="wb-delete" danger><Trash2 className="h-4 w-4" /><L>Delete</L></Btn>
    </div>
  );
}
